import React from 'react';
import { Question } from '../../types/Survey';
import './QuestionTypes.css';

interface MatrixQuestionProps {
  question: Question;
  value?: { [key: string]: string | string[] };
  onChange: (value: { [key: string]: string | string[] }) => void;
  disabled?: boolean;
}

const MatrixQuestion: React.FC<MatrixQuestionProps> = ({
  question,
  value = {},
  onChange,
  disabled = false
}) => {
  const handleValueChange = (rowIndex: number, columnValue: string) => {
    const rowKey = question.matrixRows![rowIndex];
    const newValue = { ...value };

    if (question.matrixType === 'checkbox') {
      const currentValues = (newValue[rowKey] as string[]) || [];
      if (currentValues.includes(columnValue)) {
        newValue[rowKey] = currentValues.filter(v => v !== columnValue);
      } else {
        newValue[rowKey] = [...currentValues, columnValue];
      }
    } else {
      newValue[rowKey] = columnValue;
    }

    onChange(newValue);
  };

  if (!question.matrixRows || !question.matrixColumns) {
    return <div className="error">매트릭스 질문 구성이 올바르지 않습니다.</div>;
  }

  return (
    <div className="matrix-question">
      <div className="matrix-table">
        <table>
          <thead>
            <tr>
              <th className="matrix-row-header"></th>
              {question.matrixColumns.map((column, colIndex) => (
                <th key={colIndex} className="matrix-column-header">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {question.matrixRows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td className="matrix-row-label">{row}</td>
                {question.matrixColumns!.map((column, colIndex) => (
                  <td key={colIndex} className="matrix-cell">
                    {question.matrixType === 'radio' && (
                      <input
                        type="radio"
                        name={`matrix-${question.id}-${rowIndex}`}
                        value={column}
                        checked={value[row] === column}
                        onChange={() => handleValueChange(rowIndex, column)}
                        disabled={disabled}
                        className="matrix-radio"
                      />
                    )}
                    {question.matrixType === 'checkbox' && (
                      <input
                        type="checkbox"
                        value={column}
                        checked={(value[row] as string[] || []).includes(column)}
                        onChange={() => handleValueChange(rowIndex, column)}
                        disabled={disabled}
                        className="matrix-checkbox"
                      />
                    )}
                    {question.matrixType === 'dropdown' && (
                      <select
                        value={value[row] as string || ''}
                        onChange={(e) => handleValueChange(rowIndex, e.target.value)}
                        disabled={disabled}
                        className="matrix-select"
                      >
                        <option value="">선택하세요</option>
                        {question.options?.map((option, optIndex) => (
                          <option key={optIndex} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MatrixQuestion;